import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { generalFaqs, siteMeta } from "@/mocks/site";

const origin = "https://youhuochigua.example";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    name: "常见问题 - 诱惑吃瓜",
    url: `${origin}/faq`,
    inLanguage: "zh-CN",
    mainEntity: generalFaqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "常见问题 - 诱惑吃瓜",
    url: `${origin}/faq`,
    inLanguage: "zh-CN",
    description:
      "关于诱惑吃瓜的内容来源、结论定义、纠错方式与内容边界的常见问题解答。",
  },
];

export default function Faq() {
  return (
    <>
      <Seo
        title="常见问题 - 诱惑吃瓜 内容来源与结论说明"
        description="诱惑吃瓜的内容怎么来的？实锤、反转、辟谣、待跟进分别代表什么？发现错误怎么反馈？关于内容来源、结论定义与纠错方式的问题都在这里解答。"
        keywords="诱惑吃瓜,常见问题,实锤含义,反转辟谣,内容来源,纠错反馈"
        path="/faq"
        jsonLd={jsonLd}
      />
      <SiteHeader />
      <main className="bg-background-100">
        <header className="border-b border-background-200 bg-background-50 px-4 pb-8 pt-28 md:px-8 md:pb-10 md:pt-32 lg:px-12">
          <div className="mx-auto max-w-4xl">
            <Breadcrumbs items={[{ label: "首页", path: "/" }, { label: "常见问题" }]} />
            <h1 className="mt-4 font-heading text-2xl font-bold leading-tight tracking-tight text-foreground-950 md:text-4xl">
              常见问题
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于内容来源、结论定义、纠错方式与内容边界，这里一次性说清楚。读完还是没解决的，可以直接找我们。
            </p>
          </div>
        </header>

        <div className="px-4 py-10 md:px-8 md:py-14 lg:px-12">
          <div className="mx-auto max-w-4xl">
            <FaqAccordion items={generalFaqs} />

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-lg text-primary-700">
                  <i className="ri-article-line" aria-hidden="true"></i>
                </span>
                <h2 className="mt-3 font-heading text-base font-bold text-foreground-950">
                  想看具体事件的复盘？
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  事件复盘列表支持按分类、热度和关键词筛选，能快速定位你要找的那件事。
                </p>
                <Link
                  to="/topics"
                  className="mt-4 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
                >
                  进入事件复盘列表
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </span>
                </Link>
              </div>

              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-lg text-accent-700">
                  <i className="ri-question-answer-line" aria-hidden="true"></i>
                </span>
                <h2 className="mt-3 font-heading text-base font-bold text-foreground-950">
                  还有别的问题？
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  也可以通过邮件联系 {siteMeta.email}，或使用留言表单提交你的问题与建议。
                </p>
                <Link
                  to="/contact"
                  className="mt-4 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
                >
                  前往联系我们
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}